import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card, Table } from "react-bootstrap";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { FaArrowAltCircleDown, FaArrowAltCircleRight } from "react-icons/fa";
import { basicauth } from "../Utils/Credentials";
const CircleChart = ({ percentage = 0 }) => {
  const radius = 15.9155;
  const dashArray = (percentage / 100) * 100;

  const formatNumber = (num) => {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      return Math.round(num / 1_000) + "K";
    }
    return num.toString();
  };

  return (
    <svg
      viewBox="0 0 36 36"
      style={{
        display: "block",
        margin: "10px auto",
        maxWidth: "80px",
        maxHeight: "80px",
      }}
    >
      <path
        d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831"
        style={{
          fill: "none",
          stroke: "#eee",
          strokeWidth: 3.8,
        }}
      />
      <path
        d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831"
        style={{
          fill: "none",
          stroke: "#441752",
          strokeWidth: 3.8,
          strokeLinecap: "round",
          strokeDasharray: `${dashArray}, 100`,
          transition: "stroke-dasharray 0.5s",
        }}
      />
      <text
        x="18"
        y="20.35"
        style={{
          fill: "#441752",
          fontFamily: "sans-serif",
          fontSize: "0.5rem",
          textAnchor: "middle",
          dominantBaseline: "middle",
        }}
      >
        {formatNumber(percentage)}
      </text>
    </svg>
  );
};
const ProgressBarComponent = ({ value = 0, color = "#441752" }) => {
  const cappedValue = Math.max(0, Math.min(value, 100));

  return (
    <div
      style={{
        width: "100px",
        height: "10px",
        background: "#eee",
        borderRadius: "5px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          width: `${cappedValue}%`,
          height: "100%",
          background: color,
          transition: "width 0.3s ease-in-out",
        }}
      ></div>
      <span
        style={{
          position: "absolute",
          top: "-18px",
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: "0.75rem",
          color: color,
        }}
      >
        {cappedValue}%
      </span>
    </div>
  );
};

const CustomLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "150px",
    }}
  >
    <div
      style={{
        width: "40px",
        height: "40px",
        border: "4px solid #ccc",
        borderTop: "4px solid #441752",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
    />
    <style>
      {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
    </style>
  </div>
);

const Linkingdomainchecker = () => {
  const { siteurl, siteid } = useContext(GlobalContext);
  const [linkingDomains, setLinkingDomains] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const { password, username } = basicauth;
  const [loading, setLoading] = useState(false);
  const base64Credentials = btoa(`${username}:${password}`);

  const FetchLinkingDomain = async (type) => {
    if (!domainInput.trim()) return;

    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/LinkBuilding/FetchBacklinks`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            url: domainInput,
            type: type,
          }),
        }
      );
      const data = await res.json();
      if (data.results && data.results.length > 0) {
        setTableData(data.results);
      }
    } catch (error) {
      console.error("Error fetching linking domain data:", error);
    }
    setLoading(false);
  };

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const [siteMetrics, setSiteMetrics] = useState(null);
  const FetchSiteMetrics = async (type) => {
    setLoading(true);
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchSiteMetrics`,
        {
          method: "POST",
  headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: domainInput,
            scope: "domain",
            type: type,
          }),
        }
      );
      const data = await res.json();
      if (
        data.status === "0" &&
        data.msg === "Success" &&
        data.data.length > 0
      ) {
        setSiteMetrics(data.data[0]);
      } else {
        console.log("No site metrics found.");
      }
    } catch (error) {
      console.error("Error fetching site metrics:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const styleSheet = document.styleSheets[0];

    const keyframes = `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  }, []);
  const formatNumber = (num) => {
    if (num >= 100_000) {
      return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      return Math.round(num / 1_000) + "K";
    }
    return num.toString();
  };
  const [domainInput, setDomainInput] = useState(siteurl || "");
  const handleInputChange = (e) => {
    setDomainInput(e.target.value);
  };
  return (
    <>
      <div
        className="m-3"
        style={{
          //   height: "85vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>
          {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
        </style>
        <h5 className="mb-0">Backlink checker</h5>
        <div
          className="mb-2"
          style={{
            fontSize: ".9rem",
            color: "#441752",
            opacity: 0,
            transform: "translateY(20px)",
            animation: "fadeInUp 1s ease-out forwards",
          }}
        >
        Determine the authority of a site by how many sites, of what quality and of what types are linked to them. 🚀
        </div>
        <Form className="mb-2">
          <Row className="pt-0 pb-0">
            <Col md={7} className="pr-0 pl-2">
              <Form.Group>
                <Form.Control
                  value={domainInput}
                  onChange={handleInputChange}
                  type="text"
                  placeholder="Enter your domain"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Select
                  value={selectedDomainType.value}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setSelectedDomainType({
                      value: selected,
                      label: selected === "root" ? "Root Domain" : "Sub Domain",
                    });
                  }}
                >
                  <option value="root">Root Domain</option>
                  <option value="sub">Sub Domain</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Button
                style={{ background: "#441752", color: "#fff" }}
                onClick={() => {
                  if (domainInput.trim()) {
                    FetchLinkingDomain("1");
                    FetchSiteMetrics("1");
                  }
                }}
              >
                Analyze
              </Button>
            </Col>
          </Row>
        </Form>
        {loading && <CustomLoader />}

        {siteMetrics && (
          <div
            className="mb-2 p-2"
            // style={{ background: "rgba(234,229,244)", borderRadius: ".4rem" }}
          >
            <h5 className="text-center" style={{ color: "#441752" }}>
              Result for {siteMetrics.url}
            </h5>

            <Row>
              <Col md={3}>
                <Card
                  className="p-1"
                  style={{ background: "#fff", borderRadius: "0.4rem" }}
                >
                  <h6 className="text-center">
                    <b>Domain Authority</b>
                  </h6>
                  <div
                    className="d-flex justify-content-center"
                    style={{ height: "120px" }}
                  >
                    <CircleChart percentage={Number(siteMetrics?.da || 0)} />
                  </div>
                </Card>
              </Col>

              <Col md={3}>
                <Card
                  className="p-1"
                  style={{ background: "#fff", borderRadius: "0.4rem" }}
                >
                  <h6 className="text-center">
                    <b>Page Authority</b>
                  </h6>
                  <div
                    className="d-flex justify-content-center"
                    style={{ height: "120px" }}
                  >
                    <CircleChart percentage={Number(siteMetrics?.pa || 0)} />
                  </div>
                </Card>
              </Col>

              <Col md={3}>
                <Card
                  className="p-1"
                  style={{ background: "#fff", borderRadius: "0.4rem" }}
                >
                  <h6 className="text-center">
                    <b>Linking domain </b>
                  </h6>
                  <div
                    className="d-flex justify-content-center"
                    style={{ height: "120px" }}
                  >
                    <CircleChart
                      percentage={Number(siteMetrics?.linking_domain || 0)}
                    />
                  </div>
                </Card>
              </Col>

              {/* Spam Score */}
              <Col md={3}>
                <Card
                  className="p-1"
                  style={{ background: "#fff", borderRadius: "0.4rem" }}
                >
                  {" "}
                  <h6 className="text-center">
                    <b>Spam Score</b>
                  </h6>
                  <div className="d-flex justify-content-center">
                    <CircleChart
                      percentage={Number(siteMetrics?.spam_score || 0)}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
            <Table responsive bordered className="mt-3">
              <thead>
                <tr>
                  <th>Root Domain</th>
                  <th>DA</th>
                  <th>Spam Score</th>
                  <th>Total Linking Domains</th>
                  <th>Pages</th>
                  <th>NoFollow</th>
                  <th>Redirect</th>
                  <th>Deleted</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <a
                          href={`https://${item.root_domain}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.root_domain}
                        </a>
                      </td>

                      <td>
                        <CircleChart
                          percentage={Number(item.domain_authority || 0)}
                          small
                        />
                      </td>

                      <td>
                        <ProgressBarComponent
                          value={Number(item.domain_authority || 0)}
                          color="#007bff"
                        />
                      </td>

                      <td>{formatNumber(item.root_domains_to_root_domain)}</td>
                      <td>{item.to_target.pages}</td>
                      <td>{item.to_target.nofollow_pages}</td>
                      <td>{item.to_target.redirect_pages}</td>
                      <td>{item.to_target.deleted_pages}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No linking domains found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </>
  );
};
export default Linkingdomainchecker;
